import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { SettingsApi } from '@/api/domains/settings.api';
import { SettingsQueryKeys } from '@/api/domains/settings.query-keys';

export type UseDrugExpiryDateSettingsOptions = Pick<UseQueryOptions, 'enabled' | 'keepPreviousData'>;

export const useDrugExpiryDateSettings = (options?: UseDrugExpiryDateSettingsOptions) =>
  useQuery({
    queryKey: SettingsQueryKeys.drugExpiryDateSettingsKey,
    queryFn: SettingsApi.fetchDrugExpiryDateSettings,
    staleTime: Infinity,
    ...options,
  });
